import React, { Component } from 'react';
import PropTypes from 'prop-types';
import localstorage from 'store';
import animateScrollTo from 'animated-scroll-to';
import exact from 'prop-types-exact';
import Share from '../../../common/sharing/Sharing';
import Button from '../../../common/button/Button';
import { showError, showInfo } from '../../../common/A1Alert/A1Alert';

class Recomende extends Component {
    static _validateFields(data) {
        const namesMinLength = 1; // Names for artists and musics
        const namesMaxLength = 50;
        const musicLinkMinLength = 10; // can also be null
        const musicLinkMaxLength = 70;
        const messageMinLength = 5;
        const messageMaxLength = 500;

        if (Object.prototype.hasOwnProperty.call(data, 'artistName')) {
            if (data.artistName === null || data.artistName.length < namesMinLength || data.artistName.length > namesMaxLength) {
                showError('O nome do artista ou banda deve ter de 1 a 50 caracteres.');

                return false;
            }
        }

        if (Object.prototype.hasOwnProperty.call(data, 'musicName')) {
            if (data.musicName === null || data.musicName.length < namesMinLength || data.musicName.length > namesMaxLength) {
                showError('O nome da música deve ter de 1 a 50 caracteres.');

                return false;
            }
        }


        if (Object.prototype.hasOwnProperty.call(data, 'musicLink')) {
            if (data.musicLink.length !== 0 && (data.musicLink.length < musicLinkMinLength || data.musicLink.length > musicLinkMaxLength)) {
                // if musicLink is given and it is not null, it must be within the min and max char lengths
                showError('O link da música deve ter de 10 a 70 caracteres.');

                return false;
            }
        }

        if (Object.prototype.hasOwnProperty.call(data, 'message')) {
            if (data.message === null || data.message.length < messageMinLength || data.message.length > messageMaxLength) {
                showError('A sua mensagem deve ter de 5 a 500 caracteres.');

                return false;
            }
        }

        return true;
    }

    constructor(props) {
        super(props);

        // @TODO this is not working as the input fields are not controlled inputs and thus the values set here are not applied
        const recomendeFields = localstorage.get('recomendeFields');

        this.state = {
            artistName: recomendeFields && recomendeFields.artistName,
            musicName: recomendeFields && recomendeFields.musicName,
            musicLink: recomendeFields ? recomendeFields.musicLink : '',
            message: recomendeFields && recomendeFields.message,
        };

        this._restartRecomende = this._restartRecomende.bind(this);
    }

    componentDidMount() {
        // go to top
        animateScrollTo(0, { speed: 700 });
    }

    _handleFields = (fieldId) => {
        const value = document.getElementById(fieldId).value.trim();

        // Make Validation
        if (this.constructor._validateFields({ [fieldId]: value })) {
            this.setState({
                [fieldId]: value,
            });

            // Add focus to next field
            if (fieldId === 'artistName') {
                document.getElementById('musicName').disabled = false;

                document.getElementById('musicName').focus();
            } else if (fieldId === 'musicName') {
                document.getElementById('musicLink').disabled = false;

                document.getElementById('musicLink').focus();
            } else if (fieldId === 'musicLink') {
                document.getElementById('message').disabled = false;

                document.getElementById('message').focus();
                // @TODO we should scroll further down when focusing, as the input is hidden behind the aovivo bar
            }
        }

        return false;
    }

    _handleSend = () => {
        const allFields = {
            artistName: document.getElementById('artistName').value.trim(),
            musicName: document.getElementById('musicName').value.trim(),
            musicLink: document.getElementById('musicLink').value.trim(),
            message: document.getElementById('message').value.trim(),
        };

        // @TODO check what this serves for (I think it is not necessary)
        this.setState({
            message: allFields.message,
            artistName: allFields.artistName,
            musicLink: allFields.musicLink,
            musicName: allFields.musicName,
        });

        // Set all data in browser localstorage
        localstorage.set('recomendeFields', allFields);

        if (!this.constructor._validateFields(allFields)) {
            return false;
        }

        if (!this.props.isLogged) {
            showInfo('Você precisa está logado para recomendar uma música.');

            return this.props.setModalState(true);
        }

        return this.props.sendMessage(allFields);
    }

    _restartRecomende = () => {
        // Restart Local state
        this.setState({
            artistName: null,
            musicLink: null,
            musicName: null,
            message: null,
        });

        // Clear browser localstorage
        localstorage.remove('recomendeFields');

        // Set successMessage as default
        this.props.setSuccessMessage(false);
    }

    render() {
        const { artistName, musicName, musicLink, message } = this.state;
        const shareMessage = `Eu recomendei a música ${musicName} do artista ${artistName}`;

        if (this.props.successMessage) {
            animateScrollTo(0, { speed: 700 });
        }

        return (
            <section className="recomendeSection">
                <div className="recomende-container">
                    <header>
                        <h1>
                            <img src="../../../recomendeTitle.png" alt="Recomende" />
                        </h1>
                        <p className="pageSubtitle">Seja um programador musical e envie sugestões para a nossa programação</p>
                    </header>
                    {
                        !this.props.successMessage ?
                            <div className="recomende-container-fields">
                                <div className="recomende-container-fields-block block-artistName">
                                    {/* The following labels are shown as warns but they're all correctly done, maybe it is a eslint bug... */}
                                    <label htmlFor="artistName">Qual o nome do artista ou banda?</label>
                                    <div className="fieldStyle">
                                        <input
                                            onKeyPress={(e) => { if (e.key === 'Enter') { this._handleFields('artistName'); } }}
                                            type="text"
                                            name="artistName"
                                            id="artistName"
                                            defaultValue={this.state.artistName || ''}
                                            required
                                            autoComplete="off"
                                        />
                                        <Button
                                            title="Guardar o nome do artista"
                                            className="blocks-fields-button"
                                            onClick={() => this._handleFields('artistName')}
                                        >
                                            Clique para avançar
                                        </Button>
                                    </div>
                                </div>
                                <div className={`${!artistName && 'block-disabled '} recomende-container-fields-block block-musicName`}>
                                    <label htmlFor="musicName">Qual o nome da música?</label>
                                    <div className="fieldStyle">
                                        <input
                                            onKeyPress={(e) => { if (e.key === 'Enter') { this._handleFields('musicName'); } }}
                                            defaultValue={this.state.musicName || ''}
                                            type="text"
                                            name="musicName"
                                            id="musicName"
                                            disabled={!artistName}
                                            required
                                            autoComplete="off"
                                        />
                                        <Button
                                            onClick={() => this._handleFields('musicName')}
                                            title="Guardar o nome da música"
                                            className="blocks-fields-button"
                                        >
                                            Clique para avançar
                                        </Button>
                                    </div>
                                </div>
                                <div className={` ${!musicName && 'block-disabled '} recomende-container-fields-block block-musicLink`}>
                                    <label htmlFor="musicLink">Link da música?</label>
                                    <p className="optional">(opcional)</p>
                                    <div className="fieldStyle">
                                        <input
                                            onKeyPress={(e) => { if (e.key === 'Enter') { this._handleFields('musicLink'); } }}
                                            type="text"
                                            name="musicLink"
                                            id="musicLink"
                                            defaultValue={this.state.musicLink || ''}
                                            disabled={!musicName}
                                            autoComplete="off"
                                        />

                                        <Button
                                            onClick={() => this._handleFields('musicLink')}
                                            title="Guardar o link da música"
                                            className="blocks-fields-button"
                                        >
                                            Clique para avançar
                                        </Button>
                                    </div>
                                </div>
                                <div className={`${musicLink === null && 'block-disabled'} recomende-container-fields-block block-message`}>
                                    <label htmlFor="message">Por que essa música deve tocar na antena 1?</label>
                                    <div className="fieldMessageStyle">
                                        <textarea
                                            className="fieldMessage"
                                            name="message"
                                            id="message"
                                            defaultValue={message}
                                            disabled={!musicLink}
                                            required
                                            autoComplete="off"
                                        />
                                        <div className="block-message-block-buttons">
                                            <Button
                                                onClick={this._handleSend}
                                                title="Enviar música"
                                                className={`${this.props.isSending && 'block-disabled'}`}
                                            >
                                                {this.props.isSending
                                                    ? 'Enviando...'
                                                    : 'Enviar música'}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="recomende-container-success">
                                <div className="blockMessage">
                                    <h2>Sua música foi enviada com</h2>
                                    <h3>Sucesso</h3>
                                </div>
                                <div className="shareBlockRecomende">
                                    <p>Compartilhe em suas redes sociais</p>
                                    <Share
                                        path="/recomende"
                                        styleEffect="pulseIcon"
                                        shareButtonsTo={['facebook', 'twitter', 'whatsapp']}
                                        twitter={{ title: 'Antena 1- Recomende', via: shareMessage, hashtags: ['Recomende', 'Antena1'] }}
                                        whatsapp={{ title: 'Antena 1- Recomende', description: shareMessage }}
                                        facebook={{ quote: shareMessage, hashtag: '#Antena1' }}
                                        iconSize={28}
                                        widthBlockIcon={40}
                                    />
                                </div>
                                <Button
                                    onClick={this._restartRecomende}
                                    className="sendOtherMusic"
                                    title="Envie outra música"
                                >
                                    Enviar outra música
                                </Button>
                            </div>
                    }
                </div>
            </section>
        );
    }
}


Recomende.propTypes = exact({
    sendMessage: PropTypes.func,
    isLogged: PropTypes.bool,
    setModalState: PropTypes.func,
    successMessage: PropTypes.bool,
    setSuccessMessage: PropTypes.func,
    isSending: PropTypes.bool,
});


export default Recomende;
